<template>
  <div class="head" :style="{'border-bottom':type ? '1px solid #EBEBEB':'1px solid rgba(235,235,235,0.2)'}">
    <div class="head-content">
      <div class="head-content-logo" :class="type ? '' : 'logo-white'">
        <img :src="type ? logo1 : logo2" alt="">
        <div class="head-content-logo-title">
          <div>苏州吉埃思数据信息科技</div>
          <div>Suzhou Jiaisi Information Technology Co.,Ltd</div>
        </div>
      </div>
      <ul :class="type ? 'ulblack':'ulwhite'">
        <li v-for="(item,index) in list" :key="index" :class="{'active':currentId===item.id}"><router-link :to="item.to">{{item.name}}</router-link></li>
      </ul>
    </div>    
  </div>
</template>

<script>
export default {
  name:'Head',
  data(){
    return{
      currentId:'',
      logo1:require('../assets/img/head_logo_black.png'),
      logo2:require('../assets/img/head_logo_white.png'),
      list:[
        {
          name:"网站首页",
          id:"home",
          to:"/home"
        },
        {
          name:"解决方案",
          id:"solution",
          to:"/solution"
        },
        {
          name:"技术支持",
          id:"tSupport",
          to:"/tSupport"
        },
        {
          name:"新闻中心",
          id:"news",
          to:"/news"
        },
        {
          name:"关于我们",
          id:"about",
          to:"/about"
        }
      ]
    }
  },
  watch: {
    type: {
      deep: true,  // 深度监听
      handler(newVal,oldVal) {
         console.log(newVal)
      }
    },
    $route:{
      handler(val){
        this.currentId = val.name
        if (val.path == '/solution' || val.path =='/news' || val.path =='/news/detail' || val.path =='/about') { //白底
          this.type = false
        }else{
          this.type=true
        }
      },
      immediate:true
    },
  },
  mounted(){
    // console.log(this.type);
  },
  methods:{
    
  }
}
</script>

<style lang="scss" scoped>
 .head{
    position: absolute;
    top: 0;
    z-index: 10; 
    width: 100%;   
    height: 0.75rem;
    font-size: 0.2rem;
    color: #555;
    border-bottom: 1px solid #EBEBEB;
    &-content{
      width: 12rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: auto;
      &-logo{
        text-align: center;
        display: flex;
        align-items: center;
        img{
          width: 0.5rem;
          height: 0.5rem;
        }
        >div{
          color: #555;
          >div:nth-child(1){
            font-size: 0.2rem;
            font-weight: 600;
          }
          >div:nth-child(2){
            font-size: 0.12rem;
            letter-spacing: 0.5px;
          }
        }
        &-title{
          margin: 0 5px;
        }
      }
      .logo-white{
        color: #fff !important;
        >div{
          color: #fff !important;
        }
        .head-content-logo-title{
          border-right: 2px solid #fff;
        }
      }
      ul{
        list-style-type: none;
        li{
          display: inline-block;
          margin-right: 0.4rem;
          a{
            text-decoration: none;
            color: #555;
          }
        }
      }
      .ulwhite{
        li{
          a{
            color: rgba($color: #fff, $alpha:0.4);
            // font-weight: 300;
          }
        }
        li.active{
          a{
              color: #fff;
              // font-weight: 600;
            }
        }
      } 
      .ulblack{
        li.active{
          a{
              color: #0052D9;
            }
        }
      } 
    }
    
 }
</style>